// colors

import { createTheme } from "@mui/material";

// export const primaryColor = "#004F71";//MTN MOMO BLUE
// export const primaryColor = "#1F5A2D";
export const primaryColor = "#2371B9";
export const primaryColor50 = "#3f7c500d";
// secondaryColor: changed from light amber (#f1ab1e) → dark amber (#B45309)
// because the previous value had insufficient contrast on white backgrounds,
// making secondary-colored chips, buttons, and labels nearly illegible.
// The new shade keeps the brand-orange feel but is readable as text.
export const secondaryColor = "#B45309";
export const darkColor = "#212631";

export const antdTheme = {
  token: {
    colorPrimary: primaryColor,
    fontFamily: "'Montserrat', sans-serif",
  },
  components: {
    Button: {},
  },
};

export const muiTheme = createTheme({
  palette: {
    primary: {
      main: primaryColor,
    },
    secondary: {
      // Explicitly register secondary so MUI components honour the change
      // (previously only primary.main was set, so MUI was using its default
      // pink for color="secondary").
      main: secondaryColor,
      contrastText: "#FFFFFF",
    },
  },
  typography: {
    fontSize: 13,
    button: {
      textTransform: "none",
    },
  },
});